import session from './session'
import {ENDPOINT} from './index'

export default {
  login (username, password) {
    return session.post(ENDPOINT + '/auth/login/', {username: username, password: password})
  },
  getUserInfo () {
    return session.get(ENDPOINT + '/auth/get_user_info/')
  },
  refreshToken (refresh_token) {
    return session.post(ENDPOINT + '/auth/token/refresh/', {refresh: refresh_token})
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js